import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { formatTimeStamp } from 'constants/date.helpers';
import React, { useMemo } from 'react';
import ArticleLink from './ArticleLink';
import CommonTitle from './CommonTitle';

var BriefDescription = function BriefDescription(_ref) {
  var brief = _ref.brief,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      onClicked = _ref.onClicked,
      translation = _ref.translation;
  var currentTranslation = useMemo(function () {
    var _brief$translations;

    return translation || (brief === null || brief === void 0 ? void 0 : (_brief$translations = brief.translations) === null || _brief$translations === void 0 ? void 0 : _brief$translations[0]);
  }, [translation, brief === null || brief === void 0 ? void 0 : brief.translations]);
  return /*#__PURE__*/_jsxs("div", {
    className: 'BriefDescription ' + className,
    onClick: onClicked,
    children: [/*#__PURE__*/_jsx("div", {
      className: "flexRow mobile",
      children: /*#__PURE__*/_jsx("div", {
        className: "date",
        children: formatTimeStamp(brief === null || brief === void 0 ? void 0 : brief.created_at, 'DD MMM YYYY')
      })
    }), /*#__PURE__*/_jsxs("div", {
      id: "articleContent",
      children: [/*#__PURE__*/_jsx(CommonTitle, {
        level: 4,
        children: currentTranslation.title
      }), /*#__PURE__*/_jsx(ArticleLink, {
        brief: brief
      })]
    })]
  });
};

export default BriefDescription;